export const BRANCH_GRAPH_HEIGHT_EPSILON = 1;

export function normalizeBranchGraphHeight(rawHeight) {
  return Math.ceil(rawHeight || 0);
}

export function shouldReportBranchGraphHeight(lastHeight, nextHeight, epsilon = BRANCH_GRAPH_HEIGHT_EPSILON) {
  if (lastHeight == null) return true;
  return Math.abs(lastHeight - nextHeight) > epsilon;
}

export function buildConditionBranchGraphHeightKey(conditionStepId, parentPath = []) {
  if (!parentPath?.length) return conditionStepId;
  return `${conditionStepId}:${parentPath.map((segment) => `${segment.conditionStepId}:${segment.branchId}`).join('>')}`;
}

export function createBranchGraphHeightReporter(onGraphHeightChange, lastHeightRef) {
  return (rawHeight) => {
    if (!onGraphHeightChange) return false;

    const nextHeight = normalizeBranchGraphHeight(rawHeight);
    if (!shouldReportBranchGraphHeight(lastHeightRef.current, nextHeight)) {
      return false;
    }

    lastHeightRef.current = nextHeight;
    onGraphHeightChange(nextHeight);
    return true;
  };
}
